import ActiveConfig from '../../common/activeConfig'
import {
  IPlayer, ObjectMap, PsmVideoPlayer, IEventBuilder, ITopVideoError,
} from '../../common/interfaces'
import { ENDING_EVENTS_CONFIG } from '../../common/constants'
import PsmBridge from '../../common/psm-bridge'

class TopPlayer implements IPlayer {
  player: PsmVideoPlayer
  asyncMetadata: ObjectMap
  eventBuilder: IEventBuilder

  constructor(videoPlayer: PsmVideoPlayer) {
    this.player = videoPlayer
    this.asyncMetadata = {
      unmapped: {},
      isLoaded: false,
    }
  }

  activateListeners(eventBuilder, sendPsmEventCallback): void {
    // this.player?.events?.unlistenAll()
    this.player?.events?.listen((type: string, results: any): void => {
      this.setCurrentVideoAttributes(type, results, eventBuilder)
      if (PsmBridge.psmActiveConfigEvents?.includes(type)) {
        sendPsmEventCallback(type)
      }

      if (type === 'modelUpdated') {
        if (this.player.config.analytics.conviva && !this.asyncMetadata.isLoaded) {
          this.asyncMetadata.unmapped = this.player.config.analytics.conviva
          this.asyncMetadata.isLoaded = true
        } else {
          for (let elementChanged of results.changed) {
            if (elementChanged[ 'property' ] === 'config') {
              this.asyncMetadata.unmapped = elementChanged.currentValue?.analytics?.conviva
            }
          }
        }
      }

      const endingEvents = ActiveConfig.activeConfig?.endingEvents ? ActiveConfig.activeConfig.endingEvents : ENDING_EVENTS_CONFIG
      if (endingEvents.includes(type)) {
        eventBuilder.clearVideoSession()
        eventBuilder.heartbeatTimer.stop()
      }
    })
  }

  clearError(type: string, eventBuilder) {
    if (type.indexOf('Error') === -1 && eventBuilder?.playerState?.error?.errorCode) {
      delete eventBuilder.playerState.error.errorCode
      delete eventBuilder.playerState.error.errorSeverity
      delete eventBuilder.playerState.error.errorMessage
    }
  }

  setCurrentVideoAttributes(type: string, result: ObjectMap, eventBuilder): void {
    this.clearError(type, eventBuilder)
    switch (type) {
      case 'adError':
      case 'contentError':
      case 'mediaError':
      case 'playerError':
        eventBuilder.setVideoError(result as ITopVideoError)
        break
      case 'mediaStateChanged':
        const previousVideoPosition = eventBuilder.getVideoStateAttribute('currentVideoPosition') || 0
        eventBuilder.setVideoStateAttributes('currentMediaState', result.currentState)
        eventBuilder.setVideoStateAttributes('previousMediaState', result.previousState)
        eventBuilder.setVideoStateAttributes('previousVideoPosition', previousVideoPosition)
        eventBuilder.setVideoStateAttributes('currentVideoPosition', this.player.model.mediaTime)
        break
      case 'mediaProfileChanged':
        eventBuilder.setVideoStateAttributes('bitrate', result.profile.bitrate)
        break

      default:
        break
    }
  }
}

export default TopPlayer
